import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Wrapper, Container } from "./styled";
import MainLayout from "../../commons/MainLayout";
import { files, indexing } from "../../../store/File/selectors";
import FolderListing from "../../commons/FolderListing";
import FileEdit from "../../commons/FileEdit";
import { setFlowStatus } from "../../../store/File/actions";
import {
  FLOW_STATUS_MAP,
  FLOW_STATUS_APPROVED,
} from "../../../store/File/constants";
import {
  TITLE_APPROVED_FILES,
  TITLE_EDITING_APPROVED_FILES,
} from "../../commons/MainLayout/constants";
import Alert from "../../commons/Alert";
import ModalController from "../../commons/ModalsController";
import { MODALS } from "./constants";
import { resetValues } from "../../../store/File/actions";

const ApprovedFiles = () => {
  const dispatch = useDispatch();
  const isIndexing = useSelector(indexing);
  const allFiles = useSelector(files);

  useEffect(() => {
    dispatch(resetValues());
    dispatch(setFlowStatus(FLOW_STATUS_APPROVED));
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <MainLayout
      list={allFiles[FLOW_STATUS_MAP[FLOW_STATUS_APPROVED]]}
      title={isIndexing ? TITLE_APPROVED_FILES : TITLE_EDITING_APPROVED_FILES}
    >
      <Wrapper>
        <ModalController modals={MODALS} />
        <Alert />
        <Container>
          <FolderListing />
          <FileEdit />
        </Container>
      </Wrapper>
    </MainLayout>
  );
};

export default ApprovedFiles;
